import { useWeb3React } from "@web3-react/core"
import { getContract } from "config/contracts";
import { useChainId } from "lib/chains";
import { useEffect, useState } from "react";
import multicall from "domain/multicall";
import FeeDistribution from "abis/MultiFeeDistribution.json";
import Multicall from "abis/Multicall.json";
import { BigNumber, ethers } from "ethers";
import { getWrappedToken } from "config/tokens";
const useUserLockedMMYLP = () => {
  const { account, library } = useWeb3React();
  const [info, setInfo] = useState({});
  const { chainId } = useChainId();
  const multicallAddress = getContract(chainId, "Multicall");
  const FeeDistributionAddress = getContract(chainId, "MultiFeeDistribution");
  const wrapToken = getWrappedToken(chainId);
  const fetchInfo = async () => {
    const multicallContract = new ethers.Contract(multicallAddress, Multicall.abi, library?.getSigner());
    const FeeDistributionContract = new ethers.Contract(FeeDistributionAddress, FeeDistribution.abi, library?.getSigner());
    if (FeeDistributionContract) {
      const calls = [];
      calls.push({
        address: FeeDistributionAddress,
        name: "lockInfo",
        params: [account],
      });
      calls.push({
        address: FeeDistributionAddress,
        name: "getBalances",
        params: [account],
      });
      calls.push({
        address: FeeDistributionAddress,
        name: "defaultLockIndex",
        params: [account],
      });
      calls.push({
        address: FeeDistributionAddress,
        name: "lockedBalance",
        params: [account],
      });
      calls.push({
        address: FeeDistributionAddress,
        name: "autoRelockDisabled",
        params: [account],
      });
      calls.push({
        address: FeeDistributionAddress,
        name: "claimableRewards",
        params: [account],
      });
      calls.push({
        address: FeeDistributionAddress,
        name: "earnedBalances",
        params: [account],
      });
      const dataMultiCall = await multicall(multicallContract, FeeDistribution.abi, calls);
      // console.log("???", dataMultiCall);
      if (dataMultiCall) {
        const dataLocks = dataMultiCall?.[0]?.[0];
        const lockInfos = [];
        const totalLocked = dataMultiCall?.[3]?.locked || BigNumber.from(0);
        let totalLockedDone = BigNumber.from(0);
        for (let i = 0; i < dataLocks.length; i++) {
          const dataLock = dataLocks[i];
          if (dataLock?.unlockTime.toNumber() < Date.now() / 1000) {
            totalLockedDone = totalLockedDone.add(dataLock?.amount)
          }
          else {
            const lockInfo = {
              amount: dataLock?.amount,
              duration: dataLock?.duration?.toNumber(),
              multiplier: dataLock?.multiplier?.toNumber(),
              unlockTime: dataLock?.unlockTime.toNumber(),
            }
            lockInfos.push(lockInfo)
          }
        }
        const lockType = dataMultiCall?.[2][0].toNumber()
        const autoLockDisabled = dataMultiCall?.[4][0]
        const dataVest = dataMultiCall?.[1][0];
        const claimableRewards = dataMultiCall?.[5].rewardsData
        const earnedBalances = {
          earningsData: dataMultiCall?.[6]?.earningsData,
          totalVesting: dataMultiCall?.[6]?.totalVesting,
          unlocked: dataMultiCall?.[6]?.unlocked
        }
        const vestInfo = {
          earned: dataVest?.earned,
          locked: dataVest?.locked,
          total: dataVest?.total,
          unlocked: dataVest?.unlocked,
          lockedWithMultiplier: dataVest?.lockedWithMultiplier
        }
        // console.log("????", vestInfo);
        setInfo({
          lockInfo: lockInfos,
          vestInfo,
          totalLocked,
          totalLockedDone,
          lockType,
          autoLock: !autoLockDisabled,
          earnedBalances,
          claimableRewards
        })
      }

    }
  }
  useEffect(() => {
    if (account) {
      fetchInfo();
      const interval = setInterval(async () => {
        fetchInfo();
      }, 5000);
      return () => clearInterval(interval);
    }
    else {
      setInfo([])
    }
  }, [FeeDistributionAddress, account])
  return info;
}
export default useUserLockedMMYLP;
